import type { PictogramFragment } from "@/graphql";
import type { IMultiSelectItem } from "@/interfaces";

const toMultiSelectItem = (item: PictogramFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.description || "",
    imageURL: item.source,
  };
};

export default {
  toMultiSelectItem,
};
